import type { ReactElement } from 'react';
import styles from './styles.module.scss';

export interface CardWithTitleProps {
  children: ReactElement;
  title: string;
}

function CardWithTitle({ title, children }: CardWithTitleProps) {
  return (
    <div className={styles.container}>
      <h3 className={styles.labelTitle}>{title}</h3>

      {children}
    </div>
  );
}

export { CardWithTitle };
